<section class="pt-10">
<div class="relative text-black m-20 mx-auto max-w-[800px] p-4" [innerHTML]="this.tenant.getPressRelease()"></div>
</section>